import { useEffect } from "react"
import { blockKey, useAnswerSession } from "../session"
import { useBlockScope } from "./context"

const STORE = "nira-checks:"

function stored(k: string): boolean[] | undefined {
  try {
    const v = JSON.parse(window.localStorage.getItem(STORE + k) || "null")
    return Array.isArray(v) ? v.map(Boolean) : undefined
  } catch {
    return undefined
  }
}

/** Evidence checklist, counted as "N of M done". Ticks stay with the thread on this device. */
export function Checklist({ items, path }: { items: string[]; path: string }) {
  const { turn, section } = useBlockScope()
  const k = blockKey(turn, section, path)
  const ticks = useAnswerSession((s) => s.checks[k])
  const setChecks = useAnswerSession((s) => s.setChecks)
  useEffect(() => {
    if (ticks === undefined) {
      const saved = stored(k)
      if (saved) setChecks(k, saved)
    }
  }, [k, ticks, setChecks])
  const cur = items.map((_, i) => !!ticks?.[i])
  const done = cur.filter(Boolean).length
  const tick = (i: number, on: boolean) => {
    const next = cur.map((v, j) => (j === i ? on : v))
    setChecks(k, next)
    try {
      window.localStorage.setItem(STORE + k, JSON.stringify(next))
    } catch {
      /* storage blocked: ticks hold for this visit */
    }
  }
  return (
    <div>
      <ul className="ck">
        {items.map((it, i) => (
          <li key={i}>
            <label>
              <input type="checkbox" checked={cur[i]} onChange={(e) => tick(i, e.target.checked)} />
              <span>{it}</span>
            </label>
          </li>
        ))}
      </ul>
      <p className="ckn" aria-live="polite">{done} of {items.length} done</p>
    </div>
  )
}
